import axios from "axios";
import base64 from "base-64";
import cw from "../../utils/commonwords";
import {
  SIGN_IN,
  SIGN_IN_FAILED,
  SIGN_IN_SUCCESS,
  // SIGN_OUT_FAILED,
  SIGN_OUT_SUCCESS,
  // SIGN_OUT,
  SET_USER_C,
  RESET_FORGOT_PASSWORD_TOKEN_REQUEST_SUCCESS,
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_FAILED,
  VALIDATING_TOKEN_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED,
  FORGET_PASSWORD_REQUEST_FAILED,
  FORGET_PASSWORD_REQUEST_SUCCESS,
  FORGET_PASSWORD_REQUEST,
  VALIDATING_TOKEN_SUCCESS,
  VALIDATING_TOKEN,
  RESET_PASSWORD_SUCCESS,
  RESET_ERROR_MSGS,
} from "./types";
import bugsnag from "@bugsnag/js";
import { notification } from "antd";
import { setCookie, getCookie } from "../../utils/helpers";
import { SSO_URL, SSO_WEB_URL } from "../../config/environment";
import { replace } from "connected-react-router";
const bugsnagClient = bugsnag("ab84c0b67d6464d40ea9bc8050d778e7");

// const clearUsercred = () => {
//   delCookie('user_token', getCookie('user_token'));
//   delCookie('user');
//   delCookie('user_id');
//   delCookie('esokoUserPreferences');
//   delCookie('sortedColumns');

//   return dispatch => [
//     dispatch({
//       type: SET_USER_C,
//       token: '',
//       userId: '',
//       isAuthenticated: false
//     })
//   ];
// };

const setLoginStorage = (user, account) => {
  const old = getCookie("user") || {};
  let ssoUser = {
    user_id: user.userId,
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    msisdn: user.msisdn,
    account_id: account.accountId,
    role: user.role,
    user_preferences: user.preferences || {},
    status: user.status[0],
    signup_country: user.country,
    profile_image: old.profile_image,
  };

  setCookie("user", JSON.stringify(ssoUser), 7);
  setCookie("account", JSON.stringify(account), 7);
  setCookie("user_id", ssoUser.user_id);
  setCookie("user_name", ssoUser.first_name);
  return ssoUser;
};

export const signinUser = (intl, siteLanguage, userData) => {
  const signinData = `Basic ${base64.encode(
    userData.email + ":" + userData.password
  )}`;

  return (dispatch) => {
    dispatch({
      type: SIGN_IN,
    });
    axios({
      method: "POST",
      url: `${SSO_URL}/auths/login`,
      headers: {
        Authorization: signinData,
      },
    })
      .then((response) => {
        const res = response.data;
        if (res.statusCode === 200) {
          setCookie("user_token", res.token, 7);
          setLoginStorage(res.data.user, res.data.account);
          dispatch({ type: SIGN_IN_SUCCESS, responseData: res });
          dispatch({
            type: SET_USER_C,
            token: res.token,
            userId: res.data.user.userId,
            isAuthenticated: true,
          });
        } else if (
          response.data.statusCode >= 500 &&
          response.data.statusCode < 600
        ) {
          dispatch({
            type: SIGN_IN_FAILED,
          });
        } else if (
          response.data.statusCode === 404 ||
          response.data.statusCode === 400
        ) {
          dispatch({
            type: SIGN_IN_FAILED,
          });
          notification.error({
            message: intl.formatMessage(cw.signInFailed),
            description: intl.formatMessage(cw.invalidCred),
          });
        } else if (response.data.statusCode === 410) {
          dispatch({
            type: SIGN_IN_FAILED,
          });
          notification.error({
            message: intl.formatMessage(cw.signInFailed),
            description: intl.formatMessage(cw.bruteForcePolice),
          });
        } else {
          dispatch({
            type: SIGN_IN_FAILED,
            error_msg: response.data.message,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: SIGN_IN_FAILED,
          error_msg: intl.formatMessage(cw.signInFailedDesc),
        });
        notification.error({
          message: intl.formatMessage(cw.signInFailed),
          description: intl.formatMessage(cw.signInFailedDesc),
        });
        bugsnagClient.notify(err);
      });
  };
};

export const signOutUser = (userId, intl, siteLanguage) => {
  return (dispatch) => {
    const lang = window.location.pathname.split("/")[1] || "en";
    window.location.assign(
      `${SSO_WEB_URL}/${lang}/signout?continue=${encodeURI(
        window.location.href
      )}`
    );
    dispatch({ type: SIGN_OUT_SUCCESS });

    // dispatch({ type: SIGN_OUT });
    // dispatch(clearUsercred());
    // dispatch({ type: SIGN_OUT_SUCCESS });
    // axios({
    //   method: 'POST',
    //   url: `${SSO_URL}/auths/logout`,
    //   headers: {
    //     Accept: 'application/json',
    //     'x-access-token': `${getCookie('user_token')}`
    //   }
    // })
    //   .then(response => {
    //     if (
    //       response.data.statusCode === 200 ||
    //       response.data.statusCode === 402 ||
    //       response.data.statusCode === 498
    //     ) {
    //       dispatch(clearUsercred());
    //       dispatch({ type: SIGN_OUT_SUCCESS });
    //     } else {
    //       dispatch({ type: SIGN_OUT_FAILED });
    //       notification.error({
    //         message: intl.formatMessage(cw.signOutFailed),
    //         description: intl.formatMessage(cw.signOutFailedDesc)
    //       });
    //     }
    //   })
    //   .catch(err => {
    //     dispatch({ type: SIGN_OUT_FAILED });
    //     notification.error({
    //       message: intl.formatMessage(cw.signOutFailed),
    //       description: intl.formatMessage(cw.signOutFailedDesc)
    //     });
    //   });
  };
};
export const resetForgotPasswordTokenRequestSuccess = () => {
  return (dispatch) => [
    dispatch({
      type: RESET_FORGOT_PASSWORD_TOKEN_REQUEST_SUCCESS,
    }),
  ];
};
export const resetErrorState = () => {
  return (dispatch) => [
    dispatch({
      type: RESET_ERROR_MSGS,
    }),
  ];
};

export const createAccount = (intl, siteLanguage, userData) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_ACCOUNT,
    });
    return axios({
      method: "POST",
      url: `${SSO_URL}/auths/signup`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${base64.encode(
          userData.email + ":" + userData.password
        )}`,
      },
      data: {
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        industry: userData.industry,
        msisdn: userData.msisdn.trim().replace("%2B", "+"),
        country: userData.country ? userData.country : "",
        organizationName: userData.organization || "",
        recaptcha: userData.recaptcha,
        preferences: userData.preferences ? userData.preferences : {},
        source: "dfs people",
      },
    })
      .then((response) => {
        const res = response.data;
        if (res.statusCode === 200) {
          notification.success({
            message: intl.formatMessage(cw.Success),
            description: intl.formatMessage(cw.signUpSuccess),
          });
          setCookie("user_token", res.token, 7);
          setLoginStorage(res.data.user, res.data.account);
          dispatch({
            type: SET_USER_C,
            token: res.token,
            userId: res.data.uuid,
            isAuthenticated: true,
          });
          // window.location.assign(`/${siteLanguage || 'en'}/people`);
          // dispatch(replace(`/${siteLanguage || 'en'}/people`));
        } else if (res.statusCode === 402) {
          dispatch({
            type: CREATE_ACCOUNT_FAILED,
            error_msg: "Invalid input. Fix and try again",
          });
          notification.error({
            message: intl.formatMessage(cw["Failed"]),
            description: intl.formatMessage(cw.signUpFailed),
          });
        } else {
          dispatch({
            type: CREATE_ACCOUNT_FAILED,
            error_msg: res.message,
          });
          notification.error({
            message: intl.formatMessage(cw["Failed"]),
            description: intl.formatMessage(cw.signUpFailed),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: CREATE_ACCOUNT_FAILED,
          error_msg: err,
        });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.signUpFailed),
        });
      });
  };
};

export const forgotPassword = (userName, language, intl, authType) => {
  return (dispatch) => {
    dispatch({ type: FORGET_PASSWORD_REQUEST });

    return axios({
      method: "post",
      url: `${SSO_URL}/auths/forgot`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: { userName, language },
    })
      .then((response) => {
        if (response.data.statusCode === 200) {
          if (authType === "msisdn") {
            dispatch({
              type: FORGET_PASSWORD_REQUEST_SUCCESS,
              auth_type: authType,
              forgot_password_token_request_msg: `Reset token been sent to your phone. Please use it to complete the process.`,
            });
            notification.success({
              message: intl.formatMessage(cw.Failed),
              description: intl.formatMessage(cw.resetTokenSent),
            });
          } else {
            dispatch({
              type: FORGET_PASSWORD_REQUEST_SUCCESS,
              auth_type: authType,
              forgot_password_token_request_msg: `Instructions on resetting your password has been sent to your email address. Please follow the instructions to complete the process.`,
            });
            notification.success({
              message: intl.formatMessage(cw.Failed),
              description: intl.formatMessage(cw.resetEmailSent),
            });
          }
        } else if (
          response.data.statusCode === 498 ||
          response.data.statusCode === 401
        ) {
          dispatch(signOutUser(intl, language));
        } else if (
          response.data.statusCode >= 500 &&
          response.data.statusCode < 600
        ) {
          dispatch({
            type: FORGET_PASSWORD_REQUEST_FAILED,
            forgot_password_token_request_msg: intl.formatMessage(
              cw["ResetUnable"]
            ),
          });
        } else {
          dispatch({
            type: FORGET_PASSWORD_REQUEST_FAILED,
            forgot_password_token_request_msg: intl.formatMessage(
              cw["ResetUnable"]
            ),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: FORGET_PASSWORD_REQUEST_FAILED,
          forgot_password_token_request_msg: intl.formatMessage(
            cw["ResetUnable"]
          ),
        });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.resetEmailFailed),
        });
      });
  };
};
export const verifyResetToken = (token, intl, language) => {
  return (dispatch) => {
    dispatch({
      type: VALIDATING_TOKEN,
    });
    return axios({
      method: "GET",
      url: `${SSO_URL}/auths/reset/${token}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.statusCode === 200) {
          dispatch({
            type: VALIDATING_TOKEN_SUCCESS,
            payload: response.data,
          });
        } else if (
          response.data.statusCode === 498 ||
          response.data.statusCode === 401
        ) {
          dispatch(signOutUser(intl, language));
        } else {
          dispatch({
            type: VALIDATING_TOKEN_FAILED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: VALIDATING_TOKEN_FAILED,
        });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: "Verification Failed",
        });
      });
  };
};
export const updateUserReset = (intl, userData, resetToken, language) => {
  return (dispatch) => {
    dispatch({
      type: RESET_PASSWORD,
    });
    return axios({
      method: "POST",
      url: `${SSO_URL}/auths/reset/${resetToken}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(userData),
    })
      .then((response) => {
        if (response.data.statusCode === 200) {
          dispatch({
            type: RESET_PASSWORD_SUCCESS,
          });
          notification.success({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw.passwordChanged),
          });
          // return response.data;
          dispatch(replace("/signin"));
        } else if (
          response.data.statusCode === 498 ||
          response.data.statusCode === 401
        ) {
          dispatch(signOutUser(intl, language));
        } else {
          dispatch({
            type: RESET_PASSWORD_FAILED,
          });
          notification.error({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw.resetEmailFailed),
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: RESET_PASSWORD_FAILED,
        });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.resetEmailFailed),
        });
        return err;
      });
  };
};
